/* [RR feat] Liefertermin-Picker pro Warenkorb – Liefertage aus Logifresh, ohne Postleitzahl.
   Nach dem Design-Handoff „Liefertag-Datepicker im Cart Drawer“ (Variante 2a, 22.10.2026):
   Pflichtfeld „Erste Lieferung“, Kalender klappt inline auf, Kasse bleibt gesperrt, bis ein Tag gewählt ist.
   Ausgabe unverändert: Bestell-Attribut „Liefertermin“ (Appstle-Format) + je Hauptposition „_Delivery Day“,
   „_Delivery Date“ und das sichtbare Label „Lieferung“. Das frühere Attribut „Liefer-PLZ“ wird entfernt,
   falls es noch im Warenkorb steht. Plan und Hintergrund: docs/liefertermin-picker-plan.md */
(function () {
  'use strict';

  var PROP_DAY = '_Delivery Day';
  var PROP_DATE = '_Delivery Date';
  var ATTR_ZIP = 'Liefer-PLZ'; /* alt, wird nur noch aufgeräumt */
  var LEGACY_ATTR = function (k) { return k === '[BD] Delivery Date' || k.indexOf('_Delivery Day ') === 0 || k.indexOf('_Delivery Date ') === 0; };
  var DAYS_S = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var DAYS_L = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var CACHE_MS = 10 * 60 * 1000;      /* frische Terminliste */
  var STALE_MS = 24 * 60 * 60 * 1000; /* Notfall-Reserve, falls Logifresh nicht antwortet */
  var FETCH_TIMEOUT_MS = 8000;
  var RETRY_DELAY_MS = 1200;
  var NUM_DAYS = 62;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fromKey(k) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(k || '')); return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null; }
  function fmtDE(d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
  function fmtLong(d) { return DAYS_L[d.getDay()] + ', ' + fmtDE(d); }
  function fmtShort(d) { return DAYS_S[d.getDay()] + ', ' + pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.'; }
  function fmtAria(d) { return DAYS_L[d.getDay()] + ', ' + d.getDate() + '. ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
  function fmtAppstle(d, fmt) { return String(fmt || 'DD-MM-YYYY').replace('YYYY', String(d.getFullYear())).replace('MM', pad(d.getMonth() + 1)).replace('DD', pad(d.getDate())); }
  /* Datum im Appstle-Format zurücklesen (Reihenfolge der Bausteine aus dem Format) */
  function parseByFormat(str, fmt) {
    if (!str) return null;
    var parts = String(str).match(/\d+/g); if (!parts || parts.length < 3) return null;
    var tokens = ['YYYY', 'MM', 'DD'].map(function (t) { return { t: t, i: String(fmt || 'DD-MM-YYYY').indexOf(t) }; }).filter(function (x) { return x.i >= 0; }).sort(function (a, b) { return a.i - b.i; });
    if (tokens.length < 3) return null;
    var v = {}; tokens.forEach(function (x, i) { v[x.t] = Number(parts[i]); });
    var d = new Date(v.YYYY, v.MM - 1, v.DD);
    return isNaN(d.getTime()) ? null : d;
  }
  function routes() {
    var r = window.routes || {};
    var cartUrl = r.cart_url || '/cart';
    var fix = function (u, fb) { u = u || fb; return /\.js$/.test(u) ? u : u + '.js'; };
    return { cart: cartUrl + '.js', update: fix(r.cart_update_url, '/cart/update'), change: fix(r.cart_change_url, '/cart/change') };
  }
  var ICON = {
    calendar: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',
    prev: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>',
    next: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>'
  };
  function today() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }
  function isPast(d) { return !!d && d < today(); }
  function readStore(store, k) { try { return store.getItem(k); } catch (e) { return null; } }
  function writeStore(store, k, v) { try { if (v == null) store.removeItem(k); else store.setItem(k, v); } catch (e) {} }

  /* ---------- Logifresh ---------- */
  function cacheKeyFor(shopDomain) { return 'rr_dates_' + shopDomain; }
  function readCache(cacheKey) {
    var raw = readStore(localStorage, cacheKey); if (!raw) return null;
    try { var c = JSON.parse(raw); if (c && c.data && typeof c.ts === 'number') return { data: c.data, age: Date.now() - c.ts }; } catch (e) {}
    writeStore(localStorage, cacheKey, null);
    return null;
  }
  function cacheFresh(shopDomain) { var c = readCache(cacheKeyFor(shopDomain)); return !!c && c.age < CACHE_MS; }
  function fetchOnce(url) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, FETCH_TIMEOUT_MS) : null;
    return fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (json) { if (timer) clearTimeout(timer); return json; }, function (err) { if (timer) clearTimeout(timer); throw err; });
  }
  /* Terminliste: 10 Minuten aus dem Cache, sonst Logifresh (ein automatischer zweiter Versuch bei Netz-/Serverfehler).
     Ohne PLZ liefert Logifresh die Tage der allgemeinen Versandregel – aktuell für alle Postleitzahlen gleich.
     Antwortet Logifresh gar nicht, dient eine bis zu 24 h alte Liste (nur künftige Tage) als Reserve, damit die Kasse nicht blockiert. */
  function fetchDates(apiBase, shopDomain) {
    var cacheKey = cacheKeyFor(shopDomain), cached = readCache(cacheKey);
    if (cached && cached.age < CACHE_MS) return Promise.resolve(cached.data);
    /* Theme-Einstellung darf mit oder ohne Funktionsnamen enden (…/functions/v1 oder …/functions/v1/get-available-delivery-dates) */
    var base = String(apiBase).replace(/\/+$/, '').replace(/\/get-available-delivery-dates$/, '');
    var url = base + '/get-available-delivery-dates?shop_domain=' + encodeURIComponent(shopDomain) + '&num_days=' + NUM_DAYS;
    return fetchOnce(url).catch(function () {
      return new Promise(function (res) { setTimeout(res, RETRY_DELAY_MS); }).then(function () { return fetchOnce(url); });
    }).then(function (json) {
      var data = { mode: json && json.mode ? String(json.mode) : '', dates: (json && json.dates ? json.dates : []).map(function (d) {
        return { key: String(d.delivery_date || '').slice(0, 10), label: d.weekday_label || '' };
      }).filter(function (d) { return fromKey(d.key); }) };
      writeStore(localStorage, cacheKey, JSON.stringify({ ts: Date.now(), data: data }));
      return data;
    }, function (err) {
      if (cached && cached.age < STALE_MS) {
        var t = today(), future = (cached.data.dates || []).filter(function (d) { var x = fromKey(d.key); return x && x >= t; });
        if (future.length) return { mode: cached.data.mode, dates: future, stale: true };
      }
      throw err;
    });
  }

  /* ---------- Warenkorb schreiben ---------- */
  var writeQueue = Promise.resolve();
  var sync = { busy: 0, failed: false };
  function enqueue(fn) { writeQueue = writeQueue.then(fn, fn); return writeQueue; }

  /* Attribut „Liefertermin“ und Eigenschaften aller Positionen auf den gewählten Stand bringen; alte Attribute (PLZ, Agentur-Picker) entfernen.
     Schreibt nur, was sich unterscheidet – die Aufrufe lösen kein Neu-Rendern des Drawers aus. */
  function syncCart(sel, cfg) {
    sync.busy++;
    return enqueue(function () {
      var R = routes();
      return fetch(R.cart).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }).then(function (cart) {
        var attrs = cart.attributes || {};
        var want = {};
        Object.keys(attrs).forEach(function (k) { if (LEGACY_ATTR(k) || k === ATTR_ZIP) want[k] = null; });
        var dateVal = sel ? fmtAppstle(sel, cfg.format) : null;
        if ((attrs[cfg.attribute] || null) !== dateVal) want[cfg.attribute] = dateVal;
        var p = Object.keys(want).length ? postJson(R.update, { attributes: want }) : Promise.resolve();
        var dayVal = sel ? DAYS_S[sel.getDay()] : '';
        var deVal = sel ? fmtDE(sel) : '';
        var items = cart.items || [];
        items.forEach(function (item, idx) {
          var props = item.properties && typeof item.properties === 'object' ? item.properties : {};
          var same = (props[PROP_DAY] || '') === dayVal && (props[PROP_DATE] || '') === deVal && (props[cfg.label] || '') === (sel ? dayVal + ' ' + deVal : '');
          if (same) return;
          var merged = Object.assign({}, props);
          merged[PROP_DAY] = dayVal; merged[PROP_DATE] = deVal;
          delete merged[cfg.label];
          if (sel) merged[cfg.label] = dayVal + ' ' + deVal;
          p = p.then(function () { return postJson(R.change, { line: idx + 1, quantity: item.quantity, properties: merged }); });
        });
        return p;
      }).then(function () { sync.busy--; sync.failed = false; return true; }, function () { sync.busy--; sync.failed = true; return false; });
    });
  }
  function postJson(url, body) {
    var cfg = typeof window.fetchConfig === 'function' ? window.fetchConfig('json') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    cfg = Object.assign({}, cfg, { body: JSON.stringify(body) });
    return fetch(url, cfg).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  /* ---------- Element ---------- */
  var instances = [];
  var uid = 0;

  function RrDeliveryPicker() { return Reflect.construct(HTMLElement, [], RrDeliveryPicker); }
  RrDeliveryPicker.prototype = Object.create(HTMLElement.prototype);
  RrDeliveryPicker.prototype.constructor = RrDeliveryPicker;

  RrDeliveryPicker.prototype.connectedCallback = function () {
    var el = this;
    if (instances.indexOf(el) === -1) instances.push(el);
    if (!el.uid) el.uid = ++uid;
    el.cfg = {
      apiBase: el.getAttribute('data-api-base') || '',
      shop: el.getAttribute('data-shop-domain') || '',
      attribute: el.getAttribute('data-appstle-attribute') || 'Liefertermin',
      format: el.getAttribute('data-appstle-format') || 'DD-MM-YYYY',
      label: el.getAttribute('data-checkout-label') || 'Lieferung',
      checkoutId: el.getAttribute('data-checkout-id') || 'CartDrawer-Checkout',
      formId: el.getAttribute('data-form-id') || 'CartDrawer-Form',
      rhythm: (el.getAttribute('data-rhythm') || 'jede Woche').trim(),
      hasPlan: el.getAttribute('data-has-plan') === 'true'
    };
    writeStore(localStorage, 'rr_zip', null); /* Rest des PLZ-Pickers */
    el.selected = parseByFormat(el.getAttribute('data-date') || '', el.cfg.format);
    /* Gespeicherter Termin aus einer früheren Sitzung: liegt er in der Vergangenheit, sofort verwerfen und aus dem Warenkorb entfernen */
    if (isPast(el.selected)) { el.selected = null; syncCart(null, el.cfg); }
    /* Stand, mit dem der Warenkorb gerendert wurde: solange er unverändert ist, muss beim (Neu-)Einhängen nichts geschrieben werden.
       data-needs-sync (Liquid) meldet Positionen ohne Termin-Eigenschaften oder alte Attribute, die aufgeräumt werden müssen. */
    el.syncedKey = el.getAttribute('data-needs-sync') === 'true' ? null : el.stateKey();
    el.dates = null; el.status = 'idle'; el.view = null; el.open = false; el.wantOpen = false;
    el.render();
    el.bindForm();
    if (!el.cfg.apiBase) { el.status = 'error'; el.render(); updateCheckout(); return; }
    el.loadWhenVisible();
    updateCheckout();
  };
  RrDeliveryPicker.prototype.disconnectedCallback = function () {
    var i = instances.indexOf(this); if (i !== -1) instances.splice(i, 1);
    if (this.io) { this.io.disconnect(); this.io = null; }
  };
  RrDeliveryPicker.prototype.stateKey = function () { return this.selected ? fmtAppstle(this.selected, this.cfg.format) : ''; };
  /* Warenkorb nur anfassen, wenn sich der Termin gegenüber dem letzten bekannten Stand geändert hat */
  RrDeliveryPicker.prototype.sync = function () {
    var el = this, k = el.stateKey();
    if (k === el.syncedKey) return Promise.resolve(true);
    el.syncedKey = k;
    return syncCart(el.selected, el.cfg).then(function (ok) { if (!ok && el.syncedKey === k) el.syncedKey = null; return ok; });
  };
  function isOnScreen(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.right > 0 && r.left < (window.innerWidth || document.documentElement.clientWidth) && r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }
  /* Logifresh erst fragen, wenn der Picker wirklich zu sehen ist (Drawer offen bzw. Warenkorb-Seite) – spart Aufrufe bei jedem Seitenaufruf */
  RrDeliveryPicker.prototype.loadWhenVisible = function () {
    var el = this;
    if (el.status !== 'idle') return;
    if (isOnScreen(el) || typeof IntersectionObserver !== 'function') { el.load(); return; }
    if (el.io) return;
    /* isIntersecting ist auch bei bloßer Kantenberührung wahr (zugeschobener Drawer) – daher zusätzlich echte Sichtfläche verlangen */
    el.io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting && e.intersectionRatio > 0; }) || !isOnScreen(el)) return;
      el.io.disconnect(); el.io = null;
      if (el.status === 'idle') el.load();
    }, { threshold: [0, 0.01] });
    el.io.observe(el);
  };
  RrDeliveryPicker.prototype.ensureLoaded = function () {
    if (this.status === 'idle' && this.cfg.apiBase && isOnScreen(this)) { if (this.io) { this.io.disconnect(); this.io = null; } this.load(); }
  };

  RrDeliveryPicker.prototype.load = function () {
    var el = this;
    el.status = 'loading'; el.render(); updateCheckout();
    fetchDates(el.cfg.apiBase, el.cfg.shop).then(function (data) {
      el.dates = data.dates; el.mode = data.mode; el.stale = !!data.stale;
      el.status = data.dates.length ? 'ready' : 'empty';
      el.applySelection();
    }, function () {
      el.dates = null; el.status = 'error'; el.open = false; el.wantOpen = false;
      el.render(); updateCheckout();
    });
  };

  /* Auswahl gegen die Liste prüfen: ungültig → weg. Keine Vorbelegung – der Kunde wählt den Termin bewusst.
     Hat der Kunde das Feld schon angetippt, während geladen wurde, klappt der Kalender jetzt auf. */
  RrDeliveryPicker.prototype.applySelection = function () {
    var el = this, keys = {};
    (el.dates || []).forEach(function (d) { keys[d.key] = d; });
    if (!(el.selected && keys[key(el.selected)])) el.selected = null;
    el.view = el.monthOf(el.selected || (el.dates && el.dates[0] ? fromKey(el.dates[0].key) : null));
    el.open = el.status === 'ready' && !el.selected && el.wantOpen;
    el.wantOpen = false;
    el.render();
    updateCheckout();
    el.sync();
  };
  RrDeliveryPicker.prototype.monthOf = function (d) { return d ? { y: d.getFullYear(), m: d.getMonth() } : null; };

  RrDeliveryPicker.prototype.hasFullDelivery = function () {
    return this.status === 'ready' && !!this.selected && !isPast(this.selected);
  };
  /* Termin gegen „heute“ und gegen die (ggf. neu geladene) Logifresh-Liste prüfen – z. B. wenn der Tab lange offen war */
  RrDeliveryPicker.prototype.revalidate = function () {
    var el = this;
    if (el.status !== 'ready') return;
    var stale = !cacheFresh(el.cfg.shop);
    if (isPast(el.selected) || stale) { el.selected = isPast(el.selected) ? null : el.selected; el.load(); }
  };

  RrDeliveryPicker.prototype.bindForm = function () {
    var el = this, form = document.getElementById(el.cfg.formId);
    if (!form || form.dataset.rrDeliveryGuard === 'true') return;
    form.dataset.rrDeliveryGuard = 'true';
    form.addEventListener('submit', function (e) {
      if (form.dataset.rrResubmit === 'true') { delete form.dataset.rrResubmit; return; }
      instances.forEach(function (p) { p.revalidate(); });
      if (!allReady()) { e.preventDefault(); updateCheckout(); drawAttention(); return; }
      /* Termin muss im Warenkorb stehen, bevor es zur Kasse geht: laufende Schreibvorgänge abwarten, fehlgeschlagene wiederholen */
      if (sync.busy > 0 || sync.failed) {
        e.preventDefault();
        var submitter = e.submitter || document.getElementById(el.cfg.checkoutId);
        var pending = sync.failed && sync.busy === 0 ? instances.reduce(function (p, inst) { return p.then(function () { inst.syncedKey = null; return inst.sync(); }); }, Promise.resolve()) : writeQueue;
        pending.then(function () {
          if (sync.failed) { updateCheckout(); return; }
          form.dataset.rrResubmit = 'true';
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter && submitter.form === form ? submitter : undefined); else if (submitter) submitter.click(); else form.submit();
        });
      }
    });
  };

  /* ---------- Rendering (Design-Handoff „Liefertag-Datepicker“, Variante 2a) ---------- */
  RrDeliveryPicker.prototype.render = function () {
    var el = this, ready = el.status === 'ready', open = ready && el.open, sel = ready && el.selected ? el.selected : null;
    var calId = 'rr-dp-cal-' + el.uid;
    var value, action = '', actionCmd = 'toggle';
    if (el.status === 'loading' || el.status === 'idle') { value = '<span class="rr-dp__spinner"></span>Liefertage werden geladen …'; }
    else if (el.status === 'error') { value = 'Gerade nicht abrufbar'; action = 'Erneut laden'; actionCmd = 'retry'; }
    else if (el.status === 'empty') { value = 'Zurzeit keine Liefertage'; action = 'Erneut laden'; actionCmd = 'retry'; }
    else { value = sel ? esc(fmtShort(sel)) : 'Datum wählen'; action = open ? 'Schließen' : (sel ? 'Ändern' : 'Auswählen'); }
    var cls = 'rr-dp' + (open ? ' is-open' : '') + (sel ? ' is-filled' : '') + (!sel && !open && ready ? ' is-required' : '');
    var html = '<div class="' + cls + '">' +
      '<button type="button" class="rr-dp__trigger" data-rr="' + actionCmd + '" aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="' + calId + '"' + (sel ? ' aria-label="Erste Lieferung: ' + esc(fmtAria(sel)) + '. ' + action + '"' : '') + '>' +
        '<span class="rr-dp__icon">' + ICON.calendar + '</span>' +
        '<span class="rr-dp__field"><span class="rr-dp__label">Erste Lieferung *</span><span class="rr-dp__value">' + value + '</span></span>' +
        (action ? '<span class="rr-dp__action">' + action + '</span>' : '') +
      '</button>';
    if (open) html += el.renderCalendar(calId);
    html += '</div>';
    if (sel) html += el.renderConfirm();
    el.innerHTML = html;
  };

  RrDeliveryPicker.prototype.renderCalendar = function (calId) {
    var el = this, v = el.view, keys = {};
    el.dates.forEach(function (d) { keys[d.key] = d; });
    var first = fromKey(el.dates[0].key), last = fromKey(el.dates[el.dates.length - 1].key);
    var minM = first.getFullYear() * 12 + first.getMonth(), maxM = last.getFullYear() * 12 + last.getMonth(), curM = v.y * 12 + v.m;
    var html = '<div class="rr-dp__cal" id="' + calId + '" role="group" aria-label="Ersten Liefertag wählen">';
    html += '<div class="rr-dp__cal-head"><button type="button" class="rr-dp__nav" data-rr="prev" aria-label="Voriger Monat"' + (curM <= minM ? ' disabled' : '') + '>' + ICON.prev + '</button>' +
      '<span class="rr-dp__cal-title" aria-live="polite">' + MONTHS[v.m] + ' ' + v.y + '</span>' +
      '<button type="button" class="rr-dp__nav" data-rr="next" aria-label="Nächster Monat"' + (curM >= maxM ? ' disabled' : '') + '>' + ICON.next + '</button></div>';
    html += '<div class="rr-dp__dows" aria-hidden="true">' + ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map(function (d) { return '<span class="rr-dp__dow">' + d + '</span>'; }).join('') + '</div>';
    html += '<div class="rr-dp__grid">';
    var firstDow = (new Date(v.y, v.m, 1).getDay() + 6) % 7; /* Montag = 0 */
    for (var i = 0; i < firstDow; i++) html += '<span class="rr-dp__cell rr-dp__cell--pad"></span>';
    var daysIn = new Date(v.y, v.m + 1, 0).getDate(), selKey = el.selected ? key(el.selected) : '', todayKey = key(today());
    for (var d = 1; d <= daysIn; d++) {
      var date = new Date(v.y, v.m, d), k = key(date), ok = !!keys[k], isSel = k === selKey, isToday = k === todayKey;
      html += ok
        ? '<button type="button" class="rr-dp__cell is-available' + (isSel ? ' is-selected' : '') + (isToday ? ' is-today' : '') + '" data-rr="pick" data-key="' + k + '" aria-pressed="' + (isSel ? 'true' : 'false') + '" aria-label="' + esc(fmtAria(date)) + '">' + d + '</button>'
        : '<button type="button" class="rr-dp__cell' + (isToday ? ' is-today' : '') + '" disabled aria-hidden="true" tabindex="-1">' + d + '</button>';
    }
    html += '</div>';
    html += '<div class="rr-dp__legend"><span class="rr-dp__legend-dot"></span><span>Liefertag verfügbar</span><span class="rr-dp__legend-dot rr-dp__legend-dot--filled"></span><span>Deine Wahl</span></div>';
    return html + '</div>';
  };

  /* Bestätigung unter dem Feld. „Jederzeit anpassbar, pausierbar oder kündbar.“ steht im Drawer schon als Hinweis je Abo-Position. */
  RrDeliveryPicker.prototype.renderConfirm = function () {
    var d = this.selected, day = DAYS_L[d.getDay()], text;
    if (!this.cfg.hasPlan) text = 'Deine Box kommt am <strong>' + esc(fmtLong(d)) + '</strong>.';
    else if (this.cfg.rhythm === 'jede Woche') text = 'Danach kommt deine Box <strong>jeden ' + day + '</strong>.';
    else text = 'Danach kommt deine Box <strong>' + esc(this.cfg.rhythm) + ' am ' + day + '</strong>.';
    return '<div class="rr-dp__confirm" role="status">' + text + '</div>';
  };

  /* ---------- Interaktion ---------- */
  RrDeliveryPicker.prototype.onAction = function (action, target) {
    var el = this;
    if (action === 'toggle') {
      if (el.status !== 'ready') { el.wantOpen = true; el.ensureLoaded(); return; }
      el.open = !el.open;
      if (el.open) el.view = el.monthOf(el.selected) || el.view;
      el.render();
      if (el.open) el.focusFirst();
      return;
    }
    if (action === 'retry') { el.wantOpen = true; el.load(); return; }
    if (action === 'prev' || action === 'next') { el.view.m += action === 'next' ? 1 : -1; if (el.view.m < 0) { el.view.m = 11; el.view.y--; } if (el.view.m > 11) { el.view.m = 0; el.view.y++; } el.render(); var nav = el.querySelector('[data-rr="' + action + '"]'); if (nav && !nav.disabled) nav.focus(); return; }
    if (action === 'pick') { var d = fromKey(target.getAttribute('data-key')); if (!d) return; el.selected = d; el.open = false; el.render(); updateCheckout(); el.sync(); var trig = el.querySelector('.rr-dp__trigger'); if (trig) trig.focus({ preventScroll: true }); }
  };
  RrDeliveryPicker.prototype.focusFirst = function () {
    var cell = this.querySelector('.rr-dp__cell.is-selected') || this.querySelector('.rr-dp__cell.is-available');
    if (cell) cell.focus({ preventScroll: true });
  };
  /* Pfeiltasten im Kalender: links/rechts nächster Liefertag, oben/unten eine Woche, auch über den Monatswechsel hinweg */
  RrDeliveryPicker.prototype.onGridKey = function (e, cell) {
    var el = this, step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
    if (!step) return;
    e.preventDefault();
    var cur = fromKey(cell.getAttribute('data-key')), keysList = el.dates.map(function (d) { return d.key; });
    var target = null;
    if (Math.abs(step) === 1) {
      var i = keysList.indexOf(key(cur)) + step;
      if (i >= 0 && i < keysList.length) target = fromKey(keysList[i]);
    } else {
      var probe = new Date(cur.getFullYear(), cur.getMonth(), cur.getDate() + step);
      if (keysList.indexOf(key(probe)) !== -1) target = probe;
    }
    if (!target) return;
    if (target.getMonth() !== el.view.m || target.getFullYear() !== el.view.y) { el.view = el.monthOf(target); el.render(); }
    var next = el.querySelector('.rr-dp__cell[data-key="' + key(target) + '"]');
    if (next) next.focus({ preventScroll: true });
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rr]'); if (!t) return;
    var el = t.closest('rr-delivery-picker'); if (!el || typeof el.onAction !== 'function') return;
    e.preventDefault();
    el.onAction(t.getAttribute('data-rr'), t);
  });
  document.addEventListener('keydown', function (e) {
    var cell = e.target.closest ? e.target.closest('.rr-dp__cell.is-available') : null; if (!cell) return;
    var el = cell.closest('rr-delivery-picker'); if (el && typeof el.onGridKey === 'function') el.onGridKey(e, cell);
  });

  /* ---------- Kasse sperren, bis ein Termin gewählt ist ---------- */
  function allReady() {
    var live = instances.filter(function (p) { return document.body.contains(p); });
    return live.length > 0 && live.every(function (p) { return p.hasFullDelivery(); });
  }
  function hintText() {
    var p = instances[0];
    if (!p) return '';
    if (p.status === 'loading' || p.status === 'idle') return 'Liefertage werden geladen …';
    if (sync.failed && p.hasFullDelivery()) return 'Liefertag konnte nicht gespeichert werden – bitte noch einmal auf „Zur Kasse“ tippen.';
    if (p.status === 'error') return 'Liefertage konnten nicht geladen werden. Bitte „Erneut laden“ tippen.';
    if (p.status === 'empty') return 'Zurzeit sind keine Liefertage verfügbar.';
    return 'Wähle zuerst deinen ersten Liefertag.';
  }
  function setCheckout(enabled) {
    instances.forEach(function (p) {
      var btn = document.getElementById(p.cfg ? p.cfg.checkoutId : 'CartDrawer-Checkout'); if (!btn) return;
      var wrap = btn.closest('bd-icon-curve') || btn;
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      wrap.classList.toggle('bd-cart-drawer__checkout--disabled', !enabled);
      btn.classList.toggle('bd-cart-drawer__checkout--disabled', !enabled);
      /* Hinweis direkt am Kassen-Button, solange kein Liefertag gewählt ist */
      var host = btn.closest('.cart__ctas') || wrap.parentElement;
      var hint = host ? host.querySelector('.rr-dp__cta-hint') : null;
      if (enabled) { if (hint) hint.remove(); return; }
      if (!hint && host) { hint = document.createElement('p'); hint.className = 'rr-dp__cta-hint'; hint.setAttribute('role', 'status'); host.insertBefore(hint, host.firstChild); }
      if (hint) hint.textContent = hintText();
    });
  }
  /* Klick auf den gesperrten Kassen-Button: Kalender aufklappen, zum Feld scrollen und es kurz hervorheben */
  function drawAttention() {
    var p = instances.filter(function (x) { return document.body.contains(x); })[0]; if (!p) return;
    if (p.status === 'ready' && !p.open && !p.selected) { p.open = true; p.view = p.monthOf(p.dates && p.dates[0] ? fromKey(p.dates[0].key) : null) || p.view; p.render(); }
    var box = p.querySelector('.rr-dp'); if (!box) return;
    box.classList.remove('is-attention'); void box.offsetWidth; box.classList.add('is-attention');
    if (box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var trig = p.querySelector('.rr-dp__trigger'); if (trig) trig.focus({ preventScroll: true });
  }
  function updateCheckout() {
    instances.forEach(function (p) { p.ensureLoaded(); });
    var ok = allReady();
    setCheckout(ok);
    requestAnimationFrame(function () { setCheckout(ok); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart__checkout-button'); if (!btn) return;
    if (instances.length && !allReady()) { e.preventDefault(); e.stopPropagation(); updateCheckout(); drawAttention(); }
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') instances.forEach(function (p) { p.revalidate(); });
  });

  /* Hooks, die Dawns cart-drawer.js und cart.js bereits aufrufen */
  window.bdUpdateCartDrawerCheckout = updateCheckout;
  window.bdAllCartItemsHaveDelivery = allReady;
  /* Drawer wird geschlossen: offenen Kalender zuklappen (Aufruf aus cart-drawer.js) */
  window.bdCloseDeliveryCalendars = function () {
    instances.forEach(function (p) { if (p.open) { p.open = false; p.render(); } });
  };
  /* Leerer Warenkorb: Termin-Attribute entfernen (Aufruf aus cart-drawer.js) */
  window.rrDeliveryClear = function () {
    var p = instances[0], cfg = p && p.cfg ? p.cfg : { attribute: 'Liefertermin', format: 'DD-MM-YYYY', label: 'Lieferung' };
    return syncCart(null, cfg);
  };

  if (!customElements.get('rr-delivery-picker')) customElements.define('rr-delivery-picker', RrDeliveryPicker);
})();
